import { createElement } from 'react';

import { useMaxWidth } from '@grupoboticario/flora-react';

import { WidgetWrapper } from './components';
import { filterByMatchParams } from './widgets/Slider/helpers';

import type { LayoutOptions } from './@types';
import type { ContentBuilderProps } from './ContentBuilder.d';
import type { SliderWidgetProps } from './widgets/Slider/Slider.d';
import type { PlainObject } from 'core/utilities';

export const ContentBuilder = ({ components = [], match, widgetsMapper }: ContentBuilderProps) => {
  const isMobile = useMaxWidth('992px');

  const wrapper = (
    widgetKey: string,
    layout: LayoutOptions,
    container: React.ElementType,
    options: {
      config: any;
      items: PlainObject<any>[];
    },
    matchedItems?: SliderWidgetProps['items'],
  ) => (
    <WidgetWrapper key={widgetKey} {...layout}>
      {createElement(container, { isMobile, match, widgetKey, matchedItems, ...options })}
    </WidgetWrapper>
  );
  return (
    <>
      {components
        .filter(
          ({ config: { featureToggle, visibility } }) => featureToggle && visibility !== 'app',
        )
        .map(({ component = '', layout, ...options }, position) => {
          const container = widgetsMapper[component];
          const widgetKey = `${component}-${position}`;
          if (!container) {
            return null;
          }
          if (widgetKey.includes('slider')) {
            const matchedItems = match
              ? filterByMatchParams(options.items as SliderWidgetProps['items'], match)
              : [];

            return matchedItems.length
              ? wrapper(widgetKey, layout as LayoutOptions, container, options, matchedItems)
              : null;
          }
          return wrapper(widgetKey, layout as LayoutOptions, container, options);
        })}
    </>
  );
};
